module.exports = __webpack_public_path__ + "img/products_big_can_mango.40f22711.png";